import { zIndex } from 'helpers/constants';
import styled, { StyledProps } from 'styled-components/macro';

export type DatePickerProps = StyledProps<{
  size: string;
  disabled?: boolean;
  hasError?: boolean;
}>;

export const DatePickerStyled = styled.div`
  .react-datepicker-popper .react-datepicker {
    border: unset;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: transparent;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__header {
    background-color: #fff;
    border-bottom: unset;
  }

  .react-datepicker-popper
    .react-datepicker
    .react-datepicker__header
    .react-datepicker__current-month {
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
    line-height: 13px;
    text-transform: uppercase;
    color: #666666;
    padding-top: 15px;
    padding-bottom: 15px;
    word-spacing: 20px;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__navigation {
    margin-top: 15px;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__day {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    color: #6e6e6e;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__day-name {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;
    color: #6e6e6e;
  }

  .react-datepicker-popper
    .react-datepicker
    .react-datepicker__day.react-datepicker__day--outside-month {
    color: #bcbcbc;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__today-button {
    background-color: #fff;
    border-top: unset;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    color: #1e5ab4;
    padding-bottom: 17px;
  }

  .react-datepicker-popper .react-datepicker .react-datepicker__day--selected {
    /* background-color: #1e5ab4; */
    color: #fff !important;
  }

  .react-datepicker-popper {
    z-index: ${zIndex.calendarPopup};
  }
`;

export const CustomInput = styled.div``;

export const Label = styled.div`
  font-size: 12px;
  line-height: 15px;
  color: #333333;
  margin-bottom: 2px;
  span {
    color: #cf4845;
    margin-right: 3px;
  }
`;

const size: any = {
  sm: '21px',
  md: '30px',
  lg: '30px',
};

export const InputWrapper = styled.div<DatePickerProps>`
  position: relative;
  input {
    position: relative;
    width: 100%;
    height: ${(props) => size[props.size] || '30px'};
    background-color: ${(props) => (props.disabled ? 'lightdark' : '#ffffff')};
    border: 1px solid #c3cfd9;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0 7px;
    color: #1d1e25;
    font-size: 12px;

    .error & {
      border: 1px solid #f9585f;
      box-shadow: 2px 2px 0px #ffd6d7, -2px 2px 0px #ffd6d7,
        2px -2px 0px #ffd6d7, -2px -2px 0px #ffd6d7,
        inset 0px 2px 2px rgba(0, 0, 0, 0.08);
    }

    &:focus {
      outline: none;
      border-color: ${(props) => (props.hasError ? '#f9585f' : '#2684ff')};
    }

    &:hover {
      cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    }
  }
  svg {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    fill: #0076c0;
    color: ${(props) => (props.disabled ? '#8795A2' : '#0076c0')};
    pointer-events: none;
  }
`;

export const ErrorMessage = styled.div`
  position: absolute;
  left: 0;
  color: #cf4845;
  font-size: 12px;
  top: 35px;
`;
